import SetPaginationComponent from '@src/CommonComponents/Pagination/set-pagination.component';
import {
  FooterApplyButtonStyle,
  FooterCancelButtonStyle,
  ModalFooterActionsStyle,
  ModalFooterStyle,
  PaginationWrapperStyle,
} from '../ContractIdSelectionModal.style';
import type { ContractIdData } from '../types/ContractIdModal.types';

interface ModalFooterProps {
  hasSelections: boolean;
  selectedCount: number;
  onClose: () => void;
  onApply: () => void;
  tableData: ContractIdData[];
  paginationConfig: { value: number; label: number }[];
  onPaginationChange: (event: any) => void;
}

export function ModalFooter({
  hasSelections,
  selectedCount,
  onClose,
  onApply,
  tableData,
  paginationConfig,
  onPaginationChange,
}: ModalFooterProps) {
  return (
    <ModalFooterStyle>
      {tableData.length > 0 && (
        <PaginationWrapperStyle>
          <SetPaginationComponent
            tableData={tableData}
            paginationConfig={paginationConfig}
            passToTable={onPaginationChange}
          />
        </PaginationWrapperStyle>
      )}
      <ModalFooterActionsStyle>
        <FooterCancelButtonStyle type="button" onClick={onClose}>
          Cancel
        </FooterCancelButtonStyle>
        <FooterApplyButtonStyle
          type="button"
          disabled={!hasSelections}
          aria-disabled={!hasSelections}
          onClick={onApply}
        >
          Apply {hasSelections ? `(${selectedCount})` : ''}
        </FooterApplyButtonStyle>
      </ModalFooterActionsStyle>
    </ModalFooterStyle>
  );
}
